import {WorksModel} from "src/app/models/WorksModel";
import {RealtimeInvalidationService} from "src/app/modules/shared/services/realtime-invalidation.service";
import {applyWorkUpdate} from "src/app/modules/lists/utils/work-update.util";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from "@angular/core";
import {Subscription} from "rxjs";
import {GameSeries} from "src/app/models/Game";
import {User} from "src/app/modules/auth/models/User";
import {ScreenSize} from "src/app/modules/shared/interfaces/ScreenSize.interface";
import {ScreenSizeService} from "src/app/modules/shared/services/screenSize.service";
import {SkeletonWorksComponent} from "../skeleton-works/skeleton-works.component";
import {WorkCardComponent} from "../../../works/components/work-card/work-card.component";

@Component({
  selector: "app-work-game-series",
  templateUrl: "./work-game-series.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SkeletonWorksComponent, WorkCardComponent],
})
export class WorkGameSeriesComponent implements OnChanges, OnDestroy {
  @Input() saga!: GameSeries;
  @Input() user!: User;
  public content?: WorksModel[];
  public isMobile = false;
  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly screenSizeService: ScreenSizeService,
    realtime: RealtimeInvalidationService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.subscriptions.push(
      realtime.workUpdates$.subscribe((update) => {
        const works = applyWorkUpdate(this.content ?? [], update, {
          catalog: true,
        });
        if (works !== this.content) {
          this.content = works;
          this.cdr.markForCheck();
        }
      })
    );
    const screenSizeSubscription = this.screenSizeService.screenSize$.subscribe(
      (size: ScreenSize) => {
        this.isMobile = size.isMobile;
      }
    );
    this.subscriptions.push(screenSizeSubscription);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes["saga"]) return;
    if (this.saga.parts) {
      this.content = this.saga.parts as WorksModel[];
      this.cdr.markForCheck();
    }
  }

  trackByFn(_index: number, item: WorksModel) {
    return item._id;
  }

  ngOnDestroy() {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }
}
